import { jsx as l } from "react/jsx-runtime";
const c = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M13.005 12.953c-1.243-.077-2.372-.258-3.37-.541-1.592-.453-2.895-1.178-3.874-2.157-.988-.988-1.718-2.306-2.169-3.917-.277-.988-.454-2.105-.529-3.332h1.791l.72 1.453-.547.64-.617.721.388.867c.062.14.647 1.401 1.888 2.642 1.24 1.24 2.502 1.825 2.642 1.888l.867.388.721-.617.64-.547 1.453.72v1.789l1.5-.402V10.23l-3.175-1.574-1.393 1.191S8.827 9.35 7.746 8.268c-1.08-1.081-1.579-2.195-1.579-2.195L7.358 4.68 5.784 1.505H1.522c-.012 3.441.623 7.254 3.178 9.81 2.286 2.286 5.58 3.036 8.712 3.16l-.408-1.523Z"
      }
    )
  }
);
export {
  c as Phone
};
